import { Component, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { QaiButtonComponent, QaiDialogComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { CallStoreService } from '../../library/call-store/call-store.service';

@Component({
	selector: 'app-call-roleplay-exit-modal',
	standalone: true,
	templateUrl: './call-roleplay-exit-modal.component.html',
	styleUrls: ['./call-roleplay-exit-modal.component.scss'],
	imports: [QaiDialogComponent, QaiButtonComponent, TranslocoModule],
})
export class CallRoleplayExitModalComponent implements OnChanges, OnDestroy {
	@ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;
	@Input() open: boolean = false;
	@Input() titleKey: string = 'learningPathway.EXIT_MODAL_TITLE';
	@Input() descriptionKey: string = 'learningPathway.EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS';

	@Output() confirmExit = new EventEmitter<void>();
	@Output() resume = new EventEmitter<void>();

	constructor(private callStore: CallStoreService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['open']) {
			if (changes['open'].currentValue) {
				this.dialogRef?.showModal();
				this.callStore.registerModalOpen();
			} else {
				this.dialogRef?.close();
				this.callStore.registerModalClosed();
			}
		}
	}

	onConfirmExit(): void {
		this.dialogRef?.close();
		this.confirmExit.emit();
	}

	onResume(): void {
		this.dialogRef?.close();
		this.resume.emit();
	}

	ngOnDestroy(): void {
		if (this.open) {
			this.callStore.registerModalClosed();
		}
	}
}
